import WondeAdapter from './base';

export default class Connection extends WondeAdapter {
  modelNamePlural = 'connections';
}
